import { faCircleChevronDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { createChatBotMessage } from "react-chatbot-kit";
import Intents from "./components/Intents";
import SubIntents from "./components/SubIntents";
import ContactOptions from "./components/ContactOptions";
import MenuButton from "./components/MenuButton";
import SupportOptions from "./components/SupportOptions";
import DocumentsWidget from "./components/DocumentsWidget";
import ClaimOptionsWidget from "./components/ClaimOptionsWidget";
import GeneralQueriesWidget from "./components/GeneralQueriesWidget";
import GoToQuickQuoteButton from "./components/GoToQuickQuoteButton";

const botName = "AcuBunny";
const botImage = "/images/acubot-bunny.svg";

const config = {
  botName: botName,
  customComponents: {
    header: (props) => (
      <div className="flex justify-between items-center bg-customBlue text-white p-2 rounded-t-lg">
        <div className="flex items-center">
          <img src={botImage} alt="Bot Avatar" className="p-0.5 w-10 h-10" />
          <span className="ml-2 font-semibold">{botName}</span>
        </div>
        <button
          className="text-white"
          onClick={props.onClose} // Pass function from parent
        >
          <FontAwesomeIcon
            icon={faCircleChevronDown}
            className="mr-1 hover:text-white/90"
            size="lg"
          />
        </button>
      </div>
    ),
    botAvatar: () => (
      <img src={botImage} alt="Bot Avatar" className="p-1 w-10 h-10" />
    ),
    userAvatar: () => (
      <></>
      // <span className="ml-4 p-1 w-8 h-8 rounded-full border border-customBlue">
      //   <UserIcon />
      // </span>
    ),
    userChatMessage: (props) => (
      <span
        className="px-2 py-1 rounded-lg bg-customBlue text-white"
        {...props}
      >
        {props.message}
      </span>
    ),
  },
  initialMessages: [
    createChatBotMessage(
      `Hello! Welcome to ${botName} 😊, your personal insurance assistant powered by Acuvisor. 🚀 How can I assist you today?`,
      {
        widget: "intentsWidget",
      },
    ),
  ],
  widgets: [
    {
      widgetName: "intentsWidget",
      widgetFunc: (props) => <Intents {...props} />,
    },
    {
      widgetName: "subIntentsWidget",
      widgetFunc: (props) => <SubIntents {...props} />,
    },
    // {
    //   widgetName: "suggestionsWidget",
    //   widgetFunc: (props) => <Suggestions {...props} />,
    // },
    {
      widgetName: "contactOptionsWidget",
      widgetFunc: (props) => <ContactOptions {...props} />,
    },
    {
      widgetName: "goToQuickQuoteOptionWidget",
      widgetFunc: (props) => <GoToQuickQuoteButton {...props} />,
    },
    {
      widgetName: "menuButtonWidget",
      widgetFunc: (props) => <MenuButton {...props} />,
    },
    {
      widgetName: "supportOptionsWidget",
      widgetFunc: (props) => <SupportOptions {...props} />,
    },
    {
      widgetName: "documentsWidget",
      widgetFunc: (props) => <DocumentsWidget {...props} />,
    },
    {
      widgetName: "claimOptionsWidget",
      widgetFunc: (props) => <ClaimOptionsWidget {...props} />,
    },
    {
      widgetName: "generalQueriesWidget",
      widgetFunc: (props) => <GeneralQueriesWidget {...props} />,
      mapStateToProps: ["handleBotResponse"],
    },
  ],
};

export default config;
